export const SKIP_TASK_API_URL = '/api/task-allocation/skip-task';

export const AUTO_CLOSE_DURATION = 5000;
